@keyframes banner-indicator-fill {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.indicatorFill {
  animation-name: banner-indicator-fill;
}
